<template>
    <app-modal :modal-id="modalId"
               modal-size="default"
               modal-alignment="top"
               @close-modal="closeModal"
               :modal-scroll="modalScroll"
               :modal-body-class="modalBodyClass">
        <template slot="header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button"
                    class="close outline-none"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>

        <template slot="body">
            <slot name="body"></slot>
        </template>

        <template slot="footer">
            <div :class="{'loading-opacity': preloader}">

                <button v-if="modalExtraButton == 'preview-career'"
                        type="button" 
                        class="btn btn-light mr-2"
                        @click.prevent="previewAdvert()">
                    {{ $t('preview') }} 
                </button>
                <button v-if="modalExtraButton == 'preview-onboarding'"
                        type="button" 
                        class="btn btn-light mr-2"
                        @click.prevent="previewOnboarding()">
                    {{ $t('preview') }} 
                </button>
                <button v-if="modalId === 'schedule-Modal'"
                        type="button" 
                        class="btn btn-light mr-2"
                        @click.prevent="closeModal">
                    {{ $t('do_later') }} 
                </button>
                
                
                <button v-if="modalId === 'notification-Modal'" type="button"
                        class="btn btn-primary"
                        @click.prevent="submit">
                    {{ $t('send_notification') }} 
                </button>
                <button v-else-if="modalId === 'rejection-Modal'" type="button"
                        class="btn btn-secondary"
                        @click.prevent="submit">
                    {{ $t('confirm_action') }} 
                </button>
                <button v-else-if="modalId === 'schedule-Modal'" type="button"
                        class="btn btn-primary btn-with-icon"
                        @click.prevent="submit">
                    <i class="custom-icon-set custom-icon-set-check"></i>
                    {{ $t('confirm_action') }} 
                </button>
                <button v-else type="button"
                        class="btn btn-primary btn-with-icon"
                        @click.prevent="submit">
                    <i class="custom-icon-set custom-icon-set-check"></i>
                    {{ $t('save_changes') }}
                </button>
            </div>
        </template>
    </app-modal>
</template>
<script>
    export default {
        name: "Modal",

        props: {
            title: String,
            modalId: String,
            preloader: {
                type: Boolean,
                default: false
            },
            modalScroll: {
                type: Boolean,
                default: true,
            },
            modalBodyClass: {},
            modalExtraButton: {
                type: String
            },
        },
        methods: {
            /**
             * Actions
             * */
            closeModal() {
                this.$emit('close-modal');
                $('.modal-backdrop').fadeOut('fast');
            },
            submit() {
                this.$emit('submit');
            },
            previewAdvert() {
                let previewUrl = $('#inputs_url').val();
                if(previewUrl){
                    window.open(previewUrl, '_blank').focus();
                }
            },
            previewOnboarding() {
                let candidateId = this.getUrlParameter("profile");
                if(candidateId){
                    window.open('/employee/dashboard?impersonate='+candidateId, '_blank').focus();
                }
            },

            /**
             * Helpers
             * */
            getUrlParameter(k) {
                var p = {};
                location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(s, k, v) {
                    p[k] = v;
                });
                return k ? p[k] : p;
            },
        }
    }
</script>
